import { defineAsyncComponent, type App } from 'vue'
const VueCountdown = defineAsyncComponent(() => import('@chenfengyuan/vue-countdown'));

export default {
  install(app: App<Element>): void {
    app
      .component('VueCountdown', VueCountdown)
  },
}
